import React from "react";
import { Grid, Typography } from "@material-ui/core";
import Card from "@material-ui/core/Card";
import * as Constants from "../../../../consts/Constants.js";
import Style from "../../../../styles/js/StyleCallList.js";
import Pagination from "@material-ui/lab/Pagination";
import CallInfoBox from "./call-info-box.jsx";
import Button from "@material-ui/core/Button";
import LoadingButton from '@mui/lab/LoadingButton';
import ConfirmIcon from '@mui/icons-material/Done';
import InfoIcon from '@mui/icons-material/Info';
import { useHistory } from 'react-router-dom';
import { callStates } from "../../../../plas/services/calls/models";
import { formatDateDDMMYYYYHHMM } from "../../../../plas/utils";

import service from "../../../../plas/services/calls/service.jsx";
import alerter from "../../../alerts/alerter"

export default function OpenCalls() {
  const style = Style();
  let history = useHistory();

  const [applying, setApplying] = React.useState(false);
  const [calls, setCalls] = React.useState([]);
  const [open, setOpen] = React.useState(false);
  const [callSelected, setCallSelected] = React.useState({});

  //Constantes para la paginación
  const itemsPerPage = 12;
  const [page, setPage] = React.useState(1);
  const [noOfPages, setNoOfPages] = React.useState(0);

  React.useEffect(() => {
    getCalls(page);
  }, [page]);

  const getCalls = (page) => {

    let startItem = (page - 1) * itemsPerPage;
    let endItem = page * itemsPerPage - 1;

    service.api.calls.getOpenPage(startItem,endItem,(response) => {
      if (response.result != null) {
        setCalls(response.result.data);
        setNoOfPages(Math.ceil(response.result.total / itemsPerPage));
      } else {
        alerter.showError(response.error);
      }
    });
  };

  const handleClickOpen = (callItem) => {
    setCallSelected(callItem);
    setOpen(true);
  };

  const applyCall = (call) => {
    setApplying(call.id);

    service.api.applications.create(call.id,(response) => {
      if (response.result != null) {
        history.push("/calls/my-applications/" + response.result.id);
      } else {
        alerter.showError(response.error);
      }

      setApplying(false);
    });
  }

  return (
    <div className={style.box} >
      <div className={[style.row, style.rowHeader].join(' ')}>
        <Typography variant="h4" style={{ marginBottom: "20px" }}> 
          Convocatorias abiertas 
        </Typography>
      </div>
      <div className={[style.row, style.rowContent].join(' ')}>
        <Grid container spacing={3} style={{ width: "100%", justifyContent:"center" }}>
          {calls !== undefined && calls.map((callItem) => (
              <Grid item key={callItem.id} style={{ display: "flex", justifyContent: "flex-start" }}>
              <Card>
                <div className={style.item}>
                  <div className={style.itemHeader} style={ callItem.state !== 2 ? callStates.getByCode(callItem.state).style : null}>
                    <Typography className={style.titleInitial} >
                      {callItem.name}
                    </Typography>
                  </div>
                  <div className={style.itemContent}>
                    <Typography className={style.bodyInitial}>
                      Fecha de apertura: {formatDateDDMMYYYYHHMM(callItem.startDate)}
                    </Typography>
                    <Typography className={style.bodyInitial}>
                       { callItem.state === 3 ? callStates.getByCode(callItem.state).longName : "Fecha de cierre: " + formatDateDDMMYYYYHHMM(callItem.endDate)}
                    </Typography>
                  </div>
                  <div className={style.itemFooter}>  
                    <div style={{width:"50%", paddingLeft:"15px", paddingRight:"15px"}}>
                      <Button variant="contained" 
                        style={{background: Constants.COLOR_GRAY, color: 'white' }}
                        disabled={applying}
                        startIcon={<InfoIcon/>}
                        onClick={ () => { handleClickOpen(callItem) } }>
                        Información
                      </Button>

                    </div>
                    <div style={{width:"50%", paddingLeft:"15px", paddingRight:"15px"}}>
                      <LoadingButton
                        loading={applying === callItem.id}
                        disabled={callItem.state !== 2 || applying}
                        style={ callItem.state !== 2 ? callStates.getByCode(callItem.state).style : {background: Constants.COLOR_PRIMARY, color: 'white' }}
                        loadingPosition="start"
                        startIcon={<ConfirmIcon />}
                        variant="contained"
                        onClick={() => { applyCall(callItem) }}>
                        Postularme
                      </LoadingButton>
                    </div>
                  </div>
                </div>
                </Card>
              </Grid>
            ))}
        </Grid>
      </div>
      <div className={[style.row, style.rowHeader].join(' ')}>  
        <Pagination
          style={{ justifyContent:"center", display:'flex',  marginTop: '15px', marginBottom: '15px'}}
          count={noOfPages}
          showFirstButton
          showLastButton
          onChange={(event,page) => setPage(page)}/>
      </div>
      
      { open ? (
        <CallInfoBox 
          close={() => { if (!applying) setOpen(false) }}
          call={callSelected}
          applying={applying}
          apply={() => applyCall(callSelected)} />
        ) : (null)
      }

    </div>
  );

}
